<script>
  import { onMount } from 'svelte';
  import ApiClient from '$lib/api';
  import { notify, confirm } from '@components/toast';

  import MenuDetailHeader from './MenuDetailHeader.svelte';
  import MenuForm from './MenuForm.svelte';
  import MenuListPanel from './MenuListPanel.svelte';
  import MenuLoadingOverlay from './MenuLoadingOverlay.svelte';

  const api = new ApiClient();

  let loading = false;
  let searchQuery = '';
  let menus = [];
  let form = createEmptyMenu();

  function createEmptyMenu() {
    return {
      id: null,
      code: '',
      label: '',
      description: '',
      keywords: '',
      icon: '',
      menu_group: '',
      menu_type: 'component',
      component: '',
      src: '',
      hotkey: '',
      toolbar: true,
      visible: true,
      collapse_menu: false,
      disabled: false,
      sort_order: 0
    };
  }

  async function loadMenus() {
    loading = true;

    try {
      menus = await api.get('/api/menus');

      if (menus?.length > 0) {
        selectMenu(menus[0]);
      }
    } catch (err) {
      console.error(err);
      notify.error(err?.message || 'Load menus failed');
    } finally {
      loading = false;
    }
  }

  function selectMenu(menu) {
    form = JSON.parse(JSON.stringify(menu));
  }

  function newMenu() {
    form = createEmptyMenu();
    form.sort_order = menus.length + 1;
  }

  async function saveMenu() {
    try {
      loading = true;

      if (!form.code?.trim()) {
        notify.warning('Code is required');
        return;
      }

      if (!form.label?.trim()) {
        notify.warning('Label is required');
        return;
      }

      if (form.id) {
        await api.put(`/api/menus/${form.id}`, form);
      } else {
        await api.post('/api/menus', form);
      }

      await loadMenus();

      notify.success('Menu saved successfully');
    } catch (err) {
      console.error(err);
      notify.error(err?.message || 'Save failed');
    } finally {
      loading = false;
    }
  }

  async function deleteMenu() {
    if (!form.id) return;

    const ok = await confirm({
      title: 'Xoá Menu',
      message: `Bạn có muốn xoá "${form.label}"?`,
      confirmText: 'Xoá'
    });

    if (!ok) return;

    try {
      loading = true;

      await api.delete(`/api/menus/${form.id}`);
      await loadMenus();

      form = createEmptyMenu();
    } catch (err) {
      console.error(err);
      notify.error(err?.message || 'Delete failed');
    } finally {
      loading = false;
    }
  }

  $: filteredMenus = menus.filter((menu) => {
    if (!searchQuery) return true;

    const q = searchQuery.toLowerCase();

    return (
      menu.label?.toLowerCase().includes(q) ||
      menu.code?.toLowerCase().includes(q) ||
      menu.description?.toLowerCase().includes(q)
    );
  });

  onMount(loadMenus);
</script>

<div class="min-h-full bg-slate-100 p-4 lg:p-6">
  <div class="relative mx-auto max-w-7xl">
    {#if loading}
      <MenuLoadingOverlay />
    {/if}

    <div class="grid gap-4 lg:grid-cols-[320px_minmax(0,1fr)]">
      <MenuListPanel
        {menus}
        {filteredMenus}
        bind:searchQuery
        selectedMenuId={form.id}
        onNewMenu={newMenu}
        onSelectMenu={selectMenu} />

      <section class="min-w-0 rounded-xl border border-slate-200 bg-white p-5 shadow-sm sm:p-6">
        <MenuDetailHeader formId={form.id} onDeleteMenu={deleteMenu} onSaveMenu={saveMenu} />
        <MenuForm bind:form />
      </section>
    </div>
  </div>
</div>
